/* k4k-cookie-fit.js (Boardroom fixes, 25 Oct 2026, PREVIEW first). Layout only: Shopify's own cookie banner (Customer Privacy,
   #shopify-pc__banner) and its consent logic are not changed; the Accept / Decline / Manage preferences buttons are untouched.
   - Phones: the banner text is shown as 2 lines with a "More" link that opens the full text (CSS in k4k-preview.css, "fixes5" block).
   - All widths: while the banner is open, if it would sit on a price or an Add to cart / buy button, it moves to just under the header
     (and back again if that spot is busy and the bottom is clear), so a tap on Add to cart never lands on Accept.
   - Tablets (600-1024px, Boardroom fixes2, 26 Oct 2026): instead of only bottom / under-the-header, the banner looks for the first spot
     (bottom, under the header, then anywhere in between) that does not cover a price, quantity or buy button, and stays there while it is
     still clear. Phones under 600px keep the two-spot behaviour above. Moves are CSS transforms only (no layout shift).
   - Phones and tablets (up to 1024px, Boardroom fixes3, 26 Oct 2026): the guard now also avoids every visible price text
     (any text with a £ amount in the page body or the sticky Add to cart bar: headline price, unit-price lines, pack-tile prices,
     homepage buy-card prices, collection card prices) and the "More payment options" button. It picks the clear spot nearest to where
     the banner already is (bottom first, then under the header, then anywhere in between). If no spot below the header is clear, it sits over the sticky header (no prices or buy buttons there); failing that it takes the spot
     that covers the fewest items, never a buy button if that can be avoided. Desktop (over 1024px) keeps the two-spot behaviour above.
   - Phones and tablets (Boardroom fixes4, 26 Oct 2026, approved by Jonathan 11:16 GMT): the banner never goes above the bottom of the
     header any more (it used to fall back to covering the sticky header on short phones). If no clear spot exists between the header and
     the bottom, it may overlap a few px of the secondary info box ("£X ex VAT (£Y inc VAT)" lines in .k4k-facts) and nothing else,
     taking the spot that covers the least of it. If even that is impossible (seen only on 390x664 product pages for a short scroll range),
     it slides just below the bottom edge until a spot opens up again (it stays open and undecided; nothing is covered).
   - Boardroom fixes5b (26 Oct 2026, approved by Jonathan 13:08 GMT):
     * Desktop (over 1024px) now uses the same guard as phones (never above the header, never over the headline price, the "ex VAT"
       pill, the one-time / subscription rows or any buy control) and the desktop banner is one compact row (CSS, k4k-preview.css).
     * Phones (under 750px): on short screens (up to 800px tall) the bar is compact (CSS: 1-line text with "More", smaller buttons,
       about 52px). If no clear spot exists it may cover at most 16px in total of secondary price lines (.k4k-facts info box,
       pack-tile "each" / total lines) instead of sliding off-screen. It no longer goes off-screen in any position we measured.
     * If the banner is ever moved off-screen it is made inert and aria-hidden (not focusable) until it comes back.
     * Tablets (750-1024px) behave exactly as before.
   - Boardroom fixes6 (27 Oct 2026, approved by Jonathan 08:05 GMT):
     * Phones (under 750px): the expanded "More" bar is placed with the same guard as the compact bar, so it stays clear of the headline
       price, the "ex VAT" pill, the one-time / subscription rows and every buy control (it may overlap only up to 16px of the secondary
       price lines). If the full text would not fit clear at the current scroll position, tapping More scrolls the page the shortest
       distance to a position where it does (instant, same page); if there is none within 700px it stays compact. While expanded, if
       scrolling reaches a position with no clear spot, it collapses back to the compact bar.
     * "More" target: at least 24px tall (CSS, k4k-preview.css).
   - Boardroom fixes7 (29 Oct 2026, approved by Jonathan 09:38 GMT):
     * Phones (under 750px): tapping More always expands in place — no page scroll, no dead taps. The expanded bar is placed with
       the same transform guard (prefer 0px over secondary price lines; at most 16px if a zero-overlap spot is not free). Hard
       targets (headline price, ex VAT pill, purchase rows, buy controls) stay clear. If scrolling later leaves no hard-clear
       spot, it still collapses to compact off-screen (no layout shift).
   To remove: delete this file, its <script> line in layout/theme.liquid and the "fixes5" cookie block in k4k-preview.css. */
(function(){
  var root=document.documentElement,raf=0,shift=0;
  var BUY='main .price,main product-form button[type="submit"],main button[name="add"],main .shopify-payment-button,main .loop-widget-container,main .k4k-qtyrow,main .product-form__quantity,main .quick-add__submit,.k4k-hb__price,.k4k-hb__form button,.k4k-atc__btn,.k4k-atc__price';
  var BUY_T=BUY+',main button.k4k-atc-inline,main quantity-input,main .k4k-ex,main .k4k-inc';
  function banner(){var b=document.getElementById('shopify-pc__banner');if(!b)return null;var cs=getComputedStyle(b);if(cs.display==='none'||cs.visibility==='hidden')return null;var r=b.getBoundingClientRect();return r.height>0?b:null;}
  function headerBottom(c){var h=document.querySelector('.section-header')||document.querySelector('header');if(!h)return 0;var r=h.getBoundingClientRect();return Math.max(0,Math.min(c?Math.ceil(r.bottom):Math.round(r.bottom),Math.round(window.innerHeight/3)));}
  function busy(top,bottom,left,right,sel){
    var els=document.querySelectorAll(sel||BUY),vh=window.innerHeight;
    for(var i=0;i<els.length;i++){
      var e=els[i];if(e.closest('[hidden]')||e.closest('#shopify-pc__banner'))continue;
      var r=e.getBoundingClientRect();
      if(r.width===0||r.height===0||r.bottom<0||r.top>vh)continue;
      if(e.closest('.k4k-atc')){var a=e.closest('.k4k-atc'),cs=getComputedStyle(a);if(cs.display==='none'||cs.visibility==='hidden')continue;}
      if(r.top<bottom+4&&r.bottom>top-4&&r.left<right&&r.right>left)return true;
    }
    return false;
  }
  function fixedEl(e){for(;e&&e.nodeType===1;e=e.parentElement){var p=getComputedStyle(e).position;if(p==='fixed'||p==='sticky')return true;}return false;}
  /* fixes6: would a bar of height h find an allowed spot (same rule as the guard: no buy control or price within 3px, except secondary
     price lines, at most 16px of those) if the page were scrolled by dy px? Fixed/sticky targets do not move with the page. */
  function spotAt(h,dy,L,R,tTop,bTop){
    var a=targets(),rr=[],i,j,t,k;
    for(i=0;i<a.length;i++){var isR=a[i][2],el=a[i][0],rs=isR?el.getClientRects():[el.getBoundingClientRect()],fx=fixedEl(isR?el.startContainer.parentElement:el)?0:dy,soft=!!(a[i][3]||a[i][4]);
      for(j=0;j<rs.length;j++){var r=rs[j];if(r.width===0||r.height===0||r.left>=R||r.right<=L)continue;rr.push([r.top-fx,r.bottom-fx,soft]);}}
    for(t=Math.floor(bTop);t>=tTop;t-=2){
      var s2=0,bad=false;
      for(k=0;k<rr.length;k++){
        if(rr[k][2]){var ov=Math.min(t+h,rr[k][1])-Math.max(t,rr[k][0]);if(ov>0)s2+=ov;}
        else if(rr[k][0]<t+h+3&&rr[k][1]>t-3){bad=true;break;}}
      if(!bad&&s2<=16)return true;
    }
    return false;
  }
  function collapse(){
    root.classList.remove('k4k-pc-full');
    var m=document.querySelector('.k4k-pc-more');if(m)m.setAttribute('aria-expanded','false');
    tg=null;
  }
  var hiding=0;
  /* fixes6: collapse the open bar to the compact one while it is moved off-screen (transform only), so the height change is never visible
     and adds no layout shift (CLS); two frames later it is placed again by the normal guard. */
  function hideCollapse(b,bTop){
    hiding=1;shift=Math.round(window.innerHeight+16-bTop);root.style.setProperty('--k4k-pc-shift',shift+'px');
    if(!root.classList.contains('k4k-pc-top'))root.classList.add('k4k-pc-top');inert(b,true);
    requestAnimationFrame(function(){requestAnimationFrame(function(){collapse();hiding=0;q();});});
  }
  function expand(bt){
    /* fixes7: always expand in place — never scroll the page and never leave the tap as a no-op. Placement is left to slot2. */
    root.classList.add('k4k-pc-full');bt.setAttribute('aria-expanded','true');tg=null;q();
  }
  function more(b){
    if(b.dataset.k4kMore)return;var body=b.querySelector('.shopify-pc__banner__body');var p=body&&body.querySelector('p');if(!p)return;
    b.dataset.k4kMore='1';
    var bt=document.createElement('button');bt.type='button';bt.className='k4k-pc-more';bt.textContent='More';bt.setAttribute('aria-expanded','false');
    bt.setAttribute('aria-label','Show the full cookie message');
    var bg=getComputedStyle(b).backgroundColor;if(bg&&bg!=='rgba(0, 0, 0, 0)')bt.style.setProperty('--k4k-pc-bg',bg);
    bt.addEventListener('click',function(){expand(bt);});
    body.appendChild(bt);
  }
  function check(){
    raf=0;if(hiding)return;var b=banner();
    if(!b){if(root.classList.contains('k4k-pc-top'))root.classList.remove('k4k-pc-top');shift=0;return;}
    more(b);
    var p=b.querySelector('.shopify-pc__banner__body p');
    if(p&&!root.classList.contains('k4k-pc-full'))root.classList.toggle('k4k-pc-clipped',p.scrollHeight>p.clientHeight+2);
    var r=b.getBoundingClientRect(),h=r.height;
    /* The move is done with a CSS transform (not top/bottom), so it does not count as a layout shift (CLS). */
    var hb=headerBottom(),isTop=root.classList.contains('k4k-pc-top'),vw=window.innerWidth;
    if(vw<=1024||NW){slot(r,h,(vw<750||vw>1024)?headerBottom(1):hb,b);return;}
    var bTop=r.top-(isTop?shift:0),bBot=bTop+h,tTop=hb+(window.innerWidth>=750?8:0);
    var botBusy=busy(bTop,bBot,r.left,r.right),topBusy=busy(tTop,tTop+h,r.left,r.right);
    if(!isTop&&botBusy&&!topBusy)isTop=true;
    else if(isTop&&topBusy&&!botBusy)isTop=false;
    var ns=isTop?Math.round(tTop-bTop):0;
    if(ns!==shift){shift=ns;root.style.setProperty('--k4k-pc-shift',shift+'px');}
    if(root.classList.contains('k4k-pc-top')!==isTop)root.classList.toggle('k4k-pc-top',isTop);
  }
  var BUY_HARD='main product-form button[type="submit"],main button[name="add"],main button.k4k-atc-inline,main .shopify-payment-button,main .quick-add__submit,main quantity-input,main .product-form__quantity,main .k4k-qtyrow,main .loop-widget-container,.k4k-hb__form button,.k4k-atc__btn';
  var tg=null,tgAt=0,PR=/£\s?\d/;
  function vis(e){if(e.closest('[hidden]')||e.closest('#shopify-pc__banner')||e.closest('shopify-chat'))return false;var a=e.closest('.k4k-atc');if(a){var c=getComputedStyle(a);if(c.display==='none'||c.visibility==='hidden')return false;}var cs=getComputedStyle(e);return cs.visibility!=='hidden'&&cs.display!=='none'&&+cs.opacity>0;}
  function targets(){
    var now=Date.now();if(tg&&now-tgAt<1000)return tg;tgAt=now;tg=[];var seen=[];
    function add(e,w){if(seen.indexOf(e)>=0)return;seen.push(e);if(vis(e))tg.push([e,w]);}
    var i,els=document.querySelectorAll(BUY_HARD);for(i=0;i<els.length;i++)add(els[i],100);
    els=document.querySelectorAll(BUY_T);for(i=0;i<els.length;i++)add(els[i],10);
    var roots=document.querySelectorAll('main,.k4k-atc');
    for(var j=0;j<roots.length;j++){
      var w=document.createTreeWalker(roots[j],NodeFilter.SHOW_TEXT,null),n;
      /* the price text itself (a Range over the text node), so only the lines that show a £ amount count */
      while((n=w.nextNode())){if(PR.test(n.nodeValue)&&n.parentElement&&vis(n.parentElement)){var rg=document.createRange();rg.selectNodeContents(n);tg.push([rg,10,1,!!n.parentElement.closest('.k4k-facts'),!!n.parentElement.closest('.k4k-wc__each2,.k4k-wc__tot')]);}}
    }
    return tg;
  }
  var px=0,hd=0;
  function cost(t,b,L,R){
    /* c = weight of the targets the spot would touch (3px margin, 0 = clear); hd = buy buttons actually covered; px = weighted pixel rows actually covered */
    var c=0,vh=window.innerHeight,a=targets();px=0;hd=0;
    for(var i=0;i<a.length;i++){var rs=a[i][2]?a[i][0].getClientRects():[a[i][0].getBoundingClientRect()],hit=false,hard=false;
      for(var j=0;j<rs.length;j++){var r=rs[j];
        if(r.width===0||r.height===0||r.bottom<0||r.top>vh)continue;
        if(r.top<b+3&&r.bottom>t-3&&r.left<R&&r.right>L){hit=true;var ov=Math.max(0,Math.min(b,r.bottom)-Math.max(t,r.top));px+=a[i][1]*ov;if(ov>0.5)hard=hard||a[i][1]>=100;}}
      if(hit){c+=a[i][1];if(hard)hd++;}}
    return c;
  }
  function soft(bTop,tTop,h,L,R,cur){
    var a=targets(),vh=window.innerHeight,best=null,bs=1e9,bd=1e9,t,i,j;
    var rr=[];for(i=0;i<a.length;i++){var rs=a[i][2]?a[i][0].getClientRects():[a[i][0].getBoundingClientRect()];
      for(j=0;j<rs.length;j++){var r=rs[j];if(r.width===0||r.height===0||r.bottom<0||r.top>vh||r.left>=R||r.right<=L)continue;rr.push([r.top,r.bottom,!!a[i][3]]);}}
    for(t=bTop;t>=tTop;t-=(t===bTop?Math.max(1,(bTop-tTop)%2||2):2)){
      var s2=0,bad=false;
      for(i=0;i<rr.length;i++){var ov=Math.min(t+h,rr[i][1])-Math.max(t,rr[i][0]);
        if(rr[i][2]){if(ov>0)s2=Math.max(s2,ov);}else if(ov>0){bad=true;break;}}
      if(bad)continue;var d=Math.abs(t-cur);
      if(s2<bs-1||(s2<=bs+1&&d<bd)){if(s2<bs)bs=s2;bd=d;best=t;}
    }
    return best;
  }
  function soft2(bTop,tTop,h,L,R,cur,cap){
    /* fixes5b (phones and desktop): like soft() but the secondary lines are the .k4k-facts info box AND the pack-tile "each" / total
       lines, the overlap is the SUM over all of them, and a spot is only allowed if that sum is at most cap px */
    var a=targets(),vh=window.innerHeight,best=null,bs=1e9,bd=1e9,t,i,j,rr=[];
    for(i=0;i<a.length;i++){var rs=a[i][2]?a[i][0].getClientRects():[a[i][0].getBoundingClientRect()];
      for(j=0;j<rs.length;j++){var r=rs[j];if(r.width===0||r.height===0||r.bottom<0||r.top>vh||r.left>=R||r.right<=L)continue;rr.push([r.top,r.bottom,!!(a[i][3]||a[i][4])]);}}
    for(t=Math.floor(bTop);t>=tTop;t-=1){
      var s2=0,bad=false;
      for(i=0;i<rr.length;i++){var ov=Math.min(t+h,rr[i][1])-Math.max(t,rr[i][0]);
        if(ov>0){if(rr[i][2])s2+=ov;else{bad=true;break;}}}
      if(bad||s2>cap)continue;var d=Math.abs(t-cur);
      if(s2<bs-1||(s2<=bs+1&&d<bd)){if(s2<bs)bs=s2;bd=d;best=t;}
    }
    return best;
  }
  function pick(bTop,h,hb,L,R,cur){
    /* the fixes3/fixes4 search: returns [spot, weight of what it touches (0 = clear), top limit] */
    var tTop=hb+(window.innerWidth>=750?8:0);if(tTop>bTop)tTop=bTop;
    var cands=[bTop,tTop],t;for(t=tTop+8;t<bTop;t+=8)cands.push(t);
    if(cur>=tTop-1&&cur<=bTop+1&&cost(cur,cur+h,L,R)===0)return [cur,0,tTop];
    var best=null,bc=1e9,bp=1e9,bd=1e9,bh=1e9;
    for(var i=0;i<cands.length;i++){var c=cost(cands[i],cands[i]+h,L,R),p=px,hh=hd;
      if(c===0&&i<2)return [cands[i],0,tTop];
      var d=Math.abs(cands[i]-cur);
      if(c===0?(bc!==0||d<bd):(bc!==0&&(hh<bh||(hh===bh&&(p<bp||(p===bp&&d<bd)))))){bc=c;bh=hh;bp=p;bd=d;best=cands[i];}}
    return [best,bc,tTop];
  }
  function clearHard(bTop,tMin,h,L,R,cur){
    /* fixes7: when expanded, find a spot with zero BUY_HARD overlap (buy/qty/payment/loop). May sit over the sticky header. */
    var els=document.querySelectorAll(BUY_HARD),vh=window.innerHeight,rr=[],i,e,r,t,best=null,bd=1e9;
    for(i=0;i<els.length;i++){e=els[i];if(!vis(e))continue;r=e.getBoundingClientRect();
      if(r.width===0||r.height===0||r.bottom<0||r.top>vh||r.left>=R||r.right<=L)continue;rr.push([r.top,r.bottom]);}
    for(t=Math.floor(bTop);t>=tMin;t-=1){
      var bad=false;
      for(i=0;i<rr.length;i++){if(Math.min(t+h,rr[i][1])-Math.max(t,rr[i][0])>0){bad=true;break;}}
      if(bad)continue;var d=Math.abs(t-cur);if(d<bd){bd=d;best=t;}}
    return best;
  }
  var NW=1;
  function slot2(r,h,hb,b){
    /* fixes5b, phones (<750) and desktop (>1024). Order: a clear spot (fixes3/4 search); else the spot covering at most 16px in total
       of secondary price lines (.k4k-facts info box, pack-tile "each" / total lines), nearest to where it is; never above the header
       bottom. Last resort (none seen in testing): just below the bottom edge, inert and aria-hidden. Short phones (height up to 800px)
       use a compact bar (CSS) so a spot always exists; the size never changes while open (no layout shift). */
    var L=r.left,R=r.right,bTop=r.top-shift,cur=r.top,best=null;
    var res=pick(bTop,h,hb,L,R,cur);
    if(res[1]===0)best=res[0];
    else{
      /* fixes7: prefer 0px over secondary lines; allow up to 16px only if needed */
      best=soft2(bTop,res[2],h,L,R,cur,0);
      if(best===null)best=soft2(bTop,res[2],h,L,R,cur,16);
    }
    if(best===null&&root.classList.contains('k4k-pc-full')){
      if(window.innerWidth<750){
        /* fixes7: keep expanded — never collapse. Prefer soft-allowed; else a BUY_HARD-clear spot (may cover sticky
           header/title); else least-bad pick / natural bottom. */
        best=soft2(bTop,res[2],h,L,R,cur,1e9);
        if(best===null)best=clearHard(bTop,0,h,L,R,cur);
        if(best===null)best=(res[0]!=null?res[0]:bTop);
      } else best=(res[0]!=null?res[0]:bTop);
    }
    if(best===null)best=window.innerHeight+16;
    var ns=Math.round(best-bTop);
    if(ns!==shift){shift=ns;root.style.setProperty('--k4k-pc-shift',shift+'px');tg=null;}
    var on=shift!==0;if(root.classList.contains('k4k-pc-top')!==on)root.classList.toggle('k4k-pc-top',on);
    inert(b,best>=window.innerHeight);
  }
  function inert(b,off){
    if(off){if(!b.dataset.k4kInert){b.dataset.k4kInert='1';b.setAttribute('inert','');b.setAttribute('aria-hidden','true');if(b.contains(document.activeElement))document.activeElement.blur();}}
    else if(b.dataset.k4kInert){delete b.dataset.k4kInert;b.removeAttribute('inert');b.removeAttribute('aria-hidden');}
  }
  function slot(r,h,hb,b){
    var vw=window.innerWidth;if(vw<750||vw>1024){slot2(r,h,hb,b);return;}

    /* phones and tablets: natural (bottom) position = current position minus the current shift */
    var bTop=r.top-shift,tTop=hb+(window.innerWidth>=750?8:0),L=r.left,R=r.right,cur=bTop+shift;
    if(tTop>bTop)tTop=bTop;
    var cands=[bTop,tTop],t;for(t=tTop+8;t<bTop;t+=8)cands.push(t);
    var best=null,bc=1e9,bp=1e9,bd=1e9,bh=1e9;
    /* a spot is better if it touches fewer buy buttons, then covers fewer weighted pixel rows, then is nearer */
    function better(c,hh,p,d){return c===0?(bc!==0||d<bd):(bc!==0&&(hh<bh||(hh===bh&&(p<bp||(p===bp&&d<bd)))));}
    if(cur>=tTop-1&&cur<=bTop+1&&cost(cur,cur+h,L,R)===0)best=cur;
    else{
      for(var i=0;i<cands.length;i++){var c=cost(cands[i],cands[i]+h,L,R),p=px,hh=hd;
        if(c===0&&i<2){best=cands[i];bc=0;break;}
        var d=Math.abs(cands[i]-cur);
        if(better(c,hh,p,d)){bc=c;bh=hh;bp=p;bd=d;best=cands[i];}}
      /* nothing clear between the header and the bottom: the banner may also sit over the sticky header
         (it holds no price or buy button), as low as possible so it covers the least of it. If even that is not
         fully clear (a very short phone with the whole screen full of prices and buttons), it takes the spot that
         touches the fewest buy buttons (none if at all possible) and, among those, covers the fewest pixels of prices. */
      /* fixes4: never above the header. Fallback = the spot that touches only the .k4k-facts info-box price lines, covering the least
         of them (nearest to where it is now); if none exists, slide just below the bottom edge (covers nothing). */
      if(bc>0){best=soft(bTop,tTop,h,L,R,cur);if(best===null)best=window.innerHeight+16;}
    }
    var ns=Math.round(best-bTop);
    if(ns!==shift){shift=ns;root.style.setProperty('--k4k-pc-shift',shift+'px');tg=null;}
    var on=shift!==0;
    if(root.classList.contains('k4k-pc-top')!==on)root.classList.toggle('k4k-pc-top',on);
    if(b)inert(b,best>=window.innerHeight);
  }
  function q(){if(!raf)raf=requestAnimationFrame(check);}
  var idle=0;window.addEventListener('scroll',function(){q();clearTimeout(idle);idle=setTimeout(q,180);},{passive:true});
  window.addEventListener('resize',q);
  function init(){
    q();
    if(window.MutationObserver)new MutationObserver(function(){tg=null;q();}).observe(document.body,{childList:true});
    var n=0,t=setInterval(function(){q();if(++n>40){clearInterval(t);setInterval(function(){if(banner())q();},1000);}},400);
    document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('#shopify-pc__banner'))setTimeout(q,150);},true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
